import { getQuery } from "../../search/facets/getAllAppliedRefinements";
import { normalizeRefineParameter } from "../../../../helpers/normalizeRefineParameter";
import { getNormalizedRefineForSeoImportantFacetConfig } from "../helpers";

const isFacetedNavPage = state => {
  const { category } = state;
  if (!category) {
    return false;
  }

  const {
    details: { seoImportantFacets }
  } = category;
  const { refine } = getQuery(state);

  if (!refine || !seoImportantFacets) {
    return false;
  }

  const normalizedRefine = normalizeRefineParameter({ refine });

  const facetRefineMatchesNormalizedRefine = facet => {
    const normalizedQuery = getNormalizedRefineForSeoImportantFacetConfig(
      facet
    );

    return normalizedQuery === normalizedRefine;
  };

  return seoImportantFacets.some(facetRefineMatchesNormalizedRefine);
};

export default isFacetedNavPage;
